/* @sravni/react-design-system version 0.2.71 */
import { __rest, __read, __assign } from 'tslib';
import * as React from 'react';
import { useStyles, useFormControlContext, useDebounceValue } from '@sravni/react-utils';
import '../../Slider/index.js';
import '../../NumberInput/index.js';
import modules_4fe38840 from '../styles/SliderInput.module.less.js';
import { NumberInput } from '../../NumberInput/src/NumberInput.js';
import { Slider } from '../../Slider/src/Slider.js';

/**
 * @description Enter a number within certain range with the mouse or keyboard
 *
 * @component
 * @example
 * ```jsx
 * <SliderInput
 *    placeholder="Название поля"
 *    min={30000}
 *    max={1000000}
 *    postfix="₽/мес"
 *    thousandSeparator=" "
 *    logarithmic
 *  />
 * ```
 */
var SliderInput = React.forwardRef(function (props, ref) {
    var value = props.value, _a = props.min, min = _a === void 0 ? 0 : _a, _b = props.max, max = _b === void 0 ? 100 : _b, _c = props.step, step = _c === void 0 ? 1 : _c, invalid = props.invalid, disabled = props.disabled, logarithmic = props.logarithmic, defaultValue = props.defaultValue, readOnly = props.readOnly, className = props.className, onChange = props.onChange, restProps = __rest(props, ["value", "min", "max", "step", "invalid", "disabled", "logarithmic", "defaultValue", "readOnly", "className", "onChange"]);
    var cx = useStyles(modules_4fe38840);
    var formControlContext = useFormControlContext();
    var classNames = cx(className, 'container');
    var _d = __read(React.useState(value || defaultValue), 2), innerValue = _d[0], setInnerValue = _d[1];
    var isExternalChangingValue = React.useRef(false);
    var debouncedInnerValue = useDebounceValue(innerValue || min, 300);
    var handleChangeInput = function (value) {
        isExternalChangingValue.current = false;
        setInnerValue(value);
    };
    var handleChangeSlider = function (value) {
        isExternalChangingValue.current = false;
        !readOnly && setInnerValue(value);
    };
    React.useEffect(function () {
        setInnerValue(value || defaultValue);
        isExternalChangingValue.current = true;
    }, [value]);
    React.useEffect(function () {
        !isExternalChangingValue.current && (onChange === null || onChange === void 0 ? void 0 : onChange(innerValue === '' ? undefined : innerValue));
    }, [debouncedInnerValue]);
    return (React.createElement("div", { "data-qa": "SliderInput", className: classNames },
        React.createElement(NumberInput, __assign({}, restProps, { ref: ref, value: innerValue, min: min, max: max, step: step, invalid: formControlContext.invalid || invalid, disabled: formControlContext.disabled || disabled, readOnly: readOnly, format: undefined, onChange: handleChangeInput })),
        React.createElement(Slider, { className: cx('slider'), value: innerValue || undefined, min: min, max: max, step: step, disabled: formControlContext.disabled || disabled, logarithmic: logarithmic, onChange: handleChangeSlider })));
});
SliderInput.defaultProps = {
    min: 0,
    max: 100,
    step: 1,
};
SliderInput.displayName = 'SliderInput';

export { SliderInput };
//# sourceMappingURL=SliderInput.js.map
